import { Button, Flex, ModalBody, ModalFooter, ModalHeader } from "@chakra-ui/react"
import { useRouter } from "next/router"
import { useGetTenderText } from "../../../common/hooks/queries"
import { useBrandedTranslation } from "../../../common/hooks/useBrandedTranslation"
import { TenderTextType } from "../../../common/types/product"
import { UseModalReturnTypes } from "../../../common/types/useModal"
import Loader from "../Loader"
import TenderTextArea from "./TenderTextArea"

type Props = UseModalReturnTypes & {
  title: string
  tenderTextId: string
  handleClose: () => void
}

const TenderTextModal = ({ Modal, title, tenderTextId, handleClose }: Props) => {
  const { t } = useBrandedTranslation()
  const { locale } = useRouter()

  const { data } = useGetTenderText(locale, tenderTextId)

  const outlineTexts: TenderTextType[] = data?.remarks?.list
  const longText: TenderTextType = { detailText: data?.detailText, outlineText: data?.outlineText }

  return (
    <Modal modalContentStyleProps={{ mx: { base: "4", sm: "0" } }} size="xl" customOnClose={handleClose}>
      <ModalHeader mt="8" px={{ base: "4", sm: "8" }} fontWeight="medium" fontSize={{ base: "lg", sm: "xl" }}>
        {title}
      </ModalHeader>

      <ModalBody py="0" px={{ base: "4", sm: "8" }}>
        <Flex flexDirection="column" gap="6">
          {/* Show loader inside the modal body if no data */}
          {!data && <Loader my={{ base: "53", md: "51.5" }} />}
          {/* Load outline tender text area, it is an array with 0, 1 or more elements */}
          {!!outlineTexts?.length && (
            <TenderTextArea title={t("pdp-tenderText-outline")} tenderTexts={outlineTexts} isOutline={true} />
          )}
          {/* Load long tender text area, always a single object from the data, pass an array with one object in it to the component */}
          {longText?.detailText && <TenderTextArea title={t("pdp-tenderText-longText")} tenderTexts={[longText]} />}
        </Flex>
      </ModalBody>

      <ModalFooter
        px={{ base: "4", sm: "8" }}
        py={{ base: "10", sm: "8" }}
        justifyContent={{ base: "center", sm: "flex-end" }}
      >
        <Button variant="primary" onClick={handleClose} w={{ base: "100%", sm: "auto" }}>
          {t("lst-seconderyPopup-button")}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default TenderTextModal
